/* 曹操傳・第 1 章：間行東歸（中平六年，189）
 * 史實：《三國志·武帝紀》「卓表太祖爲驍騎校尉，欲與計事。太祖乃變易姓名，間行東歸。出關，過中牟，爲亭長所疑，執詣縣，邑中或竊識之，爲請得解。」
 *       演義的「孟德獻刀」（刺董）正史沒有，放到外傳。
 * 流程：曹操變易姓名，從洛陽往東走。兩道關的守兵會盤查單身的行人：混在往東走的商隊裡過關就不起疑；
 *       一動手、或一個人在關前晃太久，關兵就識破、圍上來（不會直接輸，但少一顆星）→ 到中牟被亭長起疑、押進縣城 →
 *       縣裡有人暗中認出他、替他說情 → 出縣城東門即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, TROOPS } from '../kit.ts';
import { PASSES, ROAD_Y, TOWN, JAIL, EXIT, TOWN_GATES } from '../maps/zhongmou.ts';

const LV = 3, START = [700, ROAD_Y];
const GUARD = { spec: TROOPS.dong, name: '關兵', hp: 520, maxHp: 520, atk: 30 };

export default {
  id: 'caocao-1', map: 'zhongmou', hero: 'caocao', gold: 0,
  title: '第 1 章　間行東歸', year: '中平六年（189）',
  brief: {
    quote: [{ text: '卓表太祖爲驍騎校尉，欲與計事。太祖乃變易姓名，間行東歸。', src: '《三國志·魏書·武帝紀》' }],
    text: '董卓入京，廢少帝、立獻帝，想拉攏曹操。曹操不願與他共事，改名換姓，從小路逃出洛陽往東走。（演義的「孟德獻刀」正史沒有記載，放在外傳。）',
    goals: ['混在商隊裡過兩道關', '到中牟（被亭長起疑是劇情）', '出中牟縣城'],
  },
  words: { ally: '商隊', foe: '關兵' },
  stars: [
    { text: '兩道關都沒被識破', ok: (m) => !m.vars.caught },
    { text: '一個人都沒殺', ok: (m) => m.stats.slain === 0 },
    { text: '兩分鐘內到中牟', ok: (m) => m.vars.arriveT != null && m.vars.arriveT < 120 },
  ],
  steps: [
    { // 1. 間行東歸：混在商隊裡過關
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.t0 = w.t; V.caravans = []; V.nextC = 0;
        V.guards = PASSES.map((x) => [-1, 1].map((s) => { const u = m.foe('huangjin', x + 90, ROAD_Y + s * 120, GUARD); u.asleep = true; u.sus = 0; u.home = [u.x, u.y]; return u; }));
        m.line('曹操', '董卓這廝，早晚必敗。換個名字，從小路回陳留去。');
        m.after(4, () => m.line('提示', '關兵會盤查單身的行人：跟著往東走的商隊（地上有車隊）一起過關就不會起疑。不要動手。'));
        m.obj('pass', '混在商隊裡過兩道關', 2);
        m.mark('town', TOWN.x, TOWN.y, '中牟');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        // 商隊：每 14 秒從西邊出發一隊，沿大路往東走
        V.nextC -= dt;
        if (V.nextC <= 0) {
          V.nextC = 14;
          const c = [0, 1, 2, 3].map((i) => m.folk(300 - i * 70, ROAD_Y + ((i % 2) * 2 - 1) * 40, { name: i ? '商人' : '商隊', still: true, near: 1, caravan: true, draw: i === 1 ? cart : null, look: i % 4 }));
          V.caravans.push(c);
        }
        for (const c of V.caravans) for (const f of c) if (f.x < 7400) { f.x += 85 * dt; f.walk = true; f.f = 1; f.home = [f.x, f.y]; }
        const hidden = V.caravans.some((c) => c.some((f) => SG.gd(f.x, f.y, me.x, me.y) < 150));
        V.passed = PASSES.filter((x) => me.x > x + 200).length;
        m.prog('pass', V.passed);
        // 關兵：盤查單身的人
        V.guards.forEach((pair, k) => {
          for (const u of pair) {
            if (!u.alive || !u.asleep) continue;
            const d = SG.gd(u.x, u.y, me.x, me.y);
            u.sus = Math.max(0, u.sus - dt * 6);
            if (d < 520) u.sus += dt * (hidden ? 4 : 70);
            if ((me.act && d < 600) || u.hp < u.maxHp) u.sus = 100;
            u.target = null; u.think = 0.5;
            if (u.sus >= 100) {
              V.caught = true;
              for (const o of pair) o.asleep = false;
              m.line('關兵', '站住！你不是商人——拿下！');
              for (let i = 0; i < 4; i++) m.foe('huangjin', PASSES[k] - 250 + i * 60, ROAD_Y - 420, GUARD);
              if (me.x < PASSES[k]) { m.gate('pass' + k, PASSES[k], ROAD_Y, 170, 'citygate'); m.after(8, () => m.ungate('pass' + k)); m.line('關兵', '關門！別讓他跑了！'); } // 還沒過關就被識破：關門關上 8 秒
              break;
            }
          }
        });
        return m.near(me, TOWN_GATES[0][0] - 120, ROAD_Y, 220);
      },
    },
    { // 2. 爲亭長所疑，執詣縣
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.arriveT = w.t - V.t0;
        m.done('pass'); m.unmark('town');
        m.line('中牟亭長', '這人鬼鬼祟祟的……拿下，押到縣裡去！');
        m.after(2, () => {
          m.card('出關，過中牟，爲亭長所疑，執詣縣。', '《武帝紀》');
          const p = SG.MAP.nearestFree(JAIL[0], JAIL[1]); me.x = p[0]; me.y = p[1]; me.input = {};
          w.addBuff(me, { id: '被縛', t: 12, neg: true, ms: -0.9 });
          V.jailed = w.t;
          m.gate('east', TOWN_GATES[1][0], TOWN_GATES[1][1], 140, 'citygate');
          V.clerk = m.folk(me.x + 140, me.y + 40, { name: '縣吏', still: true, near: 320, lines: [['縣吏', '……等等，這人好像是曹孟德？'], ['縣吏', '如今天下將亂，不宜拘天下英雄。'], ['縣令', '……也罷，放他走。']], onHeard: () => { V.freed = true; } });
          m.obj('wait', '被押在縣獄裡……');
        });
      },
      tick(m, w) { return !!m.vars.freed; },
    },
    { // 3. 邑中或竊識之，爲請得解
      enter(m, w) {
        m.done('wait');
        m.card('邑中或竊識之，爲請得解。', '《武帝紀》');
        m.ungate('east');
        w.addBuff(w.player, { id: '被縛', t: 0.01 });
        m.mark('exit', EXIT[0], EXIT[1], '往陳留');
        m.obj('exit', '出中牟縣城東門');
      },
      tick(m, w) {
        if (!m.near(w.player, EXIT[0], EXIT[1], 300)) return false;
        m.done('exit');
        m.line('曹操', '回陳留，散家財、合義兵！');
        m.after(3, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) { if (!w.player.alive) m.lose('曹操被擒'); },
};

// 商隊的貨車：兩個輪子、堆著布包
function cart(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 4, 50, 12, 80, 0.3);
  poly(ctx, [[-44, -12], [44, -12], [44, -28], [-44, -28]], '#7a5634', 2);
  for (const x of [-26, 26]) { ctx.beginPath(); ctx.arc(x, -6, 12, 0, Math.PI * 2); SG.draw.ink(ctx, '#4a3424', 2); }
  poly(ctx, [[-38, -28], [10, -28], [6, -52], [-34, -52]], '#c9b07a', 1.6);
  poly(ctx, [[12, -28], [40, -28], [36, -46], [14, -46]], '#8a5a3a', 1.6);
  ctx.restore();
}
